import React, { useState } from 'react';
import BackofficeBankID from 'modules/BankID/Backoffice';
import Button, { ButtonWrap } from '@hubins/components/Button';
import Heading from '@hubins/components/Heading';
import { swedishSsn } from "components/Validation";
import { __ } from 'localisation';
import { useBankIdHistory } from 'queries/bankId';
import SimpleTable from 'modules/Tables/SimpleTable';
import Box from 'components/Box';
import FormSelect from 'components/FormSelect';

const headers = [
  {
    Header: __('created_at'),
    accessor: 'created_at',
  },
  {
    Header: __('status'),
    accessor: 'status',
    Cell: ({ value }) => {
      if (value === 'complete') {
        return <span className="c-success">{__('completed')}</span>;
      }
      return <span className={value === 'failed' ? "c-danger" : "c-warning"}>{__(value)}</span>;
    },
  },
]

const PhoneAuthBankId = ({ nationalIdentityNumber }: { nationalIdentityNumber: string }) => {
  const [startBankid, setStartBankid] = useState(false);
  const [isSuccessful, setIsSuccessful] = useState(false);
  const [isAborted, setIsAborted] = useState(false);
  const [callInitiator, setCallInitiator] = useState('');

  const { data: bankIdHistory, refetch } = useBankIdHistory(nationalIdentityNumber);

  const handleBankidSuccess = () => {
    setIsSuccessful(true);
    setStartBankid(false);
    setIsAborted(false);
    setCallInitiator('');
    refetch();
  };

  const handleBankidAbort = () => {
    setIsSuccessful(false);
    setStartBankid(false);
    setIsAborted(true);
    setCallInitiator('');
    refetch();
  };

  // Confusing but returns true if invalid
  if (swedishSsn(nationalIdentityNumber, 'input', true)) {
    return (
      <>
        <Heading size="4" className="c-danger">{__('invalid_national_identity_number')}</Heading>
        <p>{__('invalid_national_identity_number_description')}</p>
      </>
    );
  }

  return (
    <>
      {isSuccessful && (
        <Heading size="4" className="c-success s-bottom-xl">
          {__('bankid_completed')}
        </Heading>
      )}
      {isAborted && (
        <Heading size="4" className="c-danger s-bottom-xl">
          {__('bankid_aborted')}
        </Heading>
      )}
      {/* <Heading size="5" className="s-bottom-md maxwidth">{__('bankid_start_client_sign_description')}</Heading> */}
      <Box bg="neutral-3" className="maxwidth">
        <Heading size="5">
          {__('call_initiator')}
        </Heading>
        <ButtonWrap>
          <Button className={`${callInitiator === 'user' ? 'cta' : 'white'}`} onClick={() => setCallInitiator('user')}>{__('the_client')}</Button>
          <Button className={`${callInitiator === 'RP' ? 'cta' : 'white'}`} iconColor="white" onClick={() => setCallInitiator('RP')}>Hubins</Button>
        </ButtonWrap>
        <Button  className="cta s-top-l" size="large" icon="bankid" iconSize={24} iconColor="white" onClick={() => setStartBankid(true)} loading={startBankid} disabled={startBankid || !callInitiator}>{__('start_bankid_identification')}</Button>
      </Box>
      {startBankid && (
        <BackofficeBankID
          nationalIdentityNumber={nationalIdentityNumber}
          callback={handleBankidSuccess}
          abortCallback={handleBankidAbort}
          callInitiator={callInitiator}
        />
      )}
      <div className="maxwidth s-top-xl">
        <Heading size="4" className="s-bottom-md">{__('bankid_history_title')}</Heading>
        <SimpleTable
          headers={headers}
          data={bankIdHistory || []}
        />
      </div>
    </>
  )
};

export default PhoneAuthBankId;